import { jsx as _jsx } from "react/jsx-runtime";
import { RoutesList } from "@/router/routesList";
import PlaceDetailsPage from "@/views/places/placeDetails";
import { PlaceCreatePage, PlaceUpdatePage } from "@/views/places/placeEdit";
import { ScheduleCreatePage, ScheduleTemplatesPage, ScheduleUpdatePage, } from "@/views/places/placeSchedule";
import PlacesListPage from "@/views/places/placesList";
import { PlaceSlotsPage } from "@/views/places/placeSlots";
import { ProtectedRoute } from "../ProtectedRoute";
/** Роуты для площадок */
export var routesPlace = [
    {
        path: RoutesList.Place.getPlacesList(),
        element: _jsx(PlacesListPage, {}),
    },
    {
        path: RoutesList.Place.getPlaceDetails(":placeId"),
        element: _jsx(PlaceDetailsPage, {}),
    },
    {
        path: RoutesList.Place.getPlaceAdd(),
        element: (_jsx(ProtectedRoute, { component: PlaceCreatePage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Place.getPlaceEdit(":placeId"),
        element: (_jsx(ProtectedRoute, { component: PlaceUpdatePage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Place.getPlaceSchedules(":placeId"),
        element: _jsx(PlaceSlotsPage, {}),
    },
    {
        path: RoutesList.Place.getPlaceScheduleTemplates(":placeId"),
        element: _jsx(ScheduleTemplatesPage, {}),
    },
    {
        path: RoutesList.Place.getScheduleAdd(":placeId"),
        element: _jsx(ScheduleCreatePage, {}),
    },
    {
        path: RoutesList.Place.getScheduleEdit(":placeId", ":scheduleId"),
        element: _jsx(ScheduleUpdatePage, {}),
    },
];
